// extracted by mini-css-extract-plugin
export var typingIndicator = "_qc-0";